import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import './styles/global.css';
import Sidebar from './components/Sidebar';
import Icon from './components/Icon';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import TumanDashboardPage from './pages/TumanDashboardPage';
import MFYPage from './pages/MFYPage';
import MFYDashboardPage from './pages/MFYDashboardPage';
import YouthPage from './pages/YouthPage';
import ProblemsPage from './pages/ProblemsPage';
import HokimQuestionsPage from './pages/HokimQuestionsPage';
import PatrioticEventsPage from './pages/PatrioticEventsPage';
import MigrantsPage from './pages/MigrantsPage';
import AIModulePage from './pages/AIModulePage';

function getUser() {
  try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
}

function ProtectedLayout() {
  const user = getUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenu, setMobileMenu] = useState(false);

  if (!user || !localStorage.getItem('access_token')) {
    return <Navigate to="/login" replace />;
  }

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const pageTitles = {
    '/': 'Boshqaruv paneli',
    '/users': 'Tuman/Shaharlar',
    '/mfy': 'MFY yettiligi',
    '/youth': 'Yoshlar reestri',
    '/problems': 'Muammolar',
    '/hokim': 'Hokimga savol',
    '/events': 'Vatanparvarlik tadbirlari',
    '/migrants': 'Migrantlar bo\'limi',
    '/ai': "Sun'iy intellekt",
  };
  const pageTitle = pageTitles[location.pathname] || 'Boshqaruv paneli';

  let subTitle = '';
  if (user.role === 'mfy') subTitle = `${user.mfy_nomi || ''} \u2022 ${user.tuman}`;
  else if (user.role === 'tuman_admin') subTitle = user.tuman;
  else subTitle = user.viloyat;
  subTitle += ` \u2014 ${new Date().toLocaleDateString('uz-UZ')}`;

  const userLabel = user.role === 'mfy' ? user.mfy_nomi : user.role === 'tuman_admin' ? user.tuman : user.viloyat;

  return (
    <div style={{ height: '100vh', display: 'flex', background: 'var(--bg)', overflow: 'hidden' }}>
      {/* Desktop sidebar */}
      <div className="desktop-sidebar">
        <Sidebar user={user} onLogout={handleLogout} />
      </div>

      {/* Mobile sidebar overlay */}
      {mobileMenu && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 999 }}>
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(2px)' }} onClick={() => setMobileMenu(false)} />
          <div style={{ position: 'relative', width: 280, height: '100%', animation: 'slideIn .25s ease' }}>
            <Sidebar user={user} onLogout={() => { handleLogout(); setMobileMenu(false); }} onNavigate={() => setMobileMenu(false)} />
            <button onClick={() => setMobileMenu(false)} style={{ position: 'absolute', top: 12, right: -44, width: 36, height: 36, borderRadius: 10, background: 'rgba(255,255,255,0.9)', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text)', fontSize: 18, cursor: 'pointer' }}>
              <Icon name="close" size={18} />
            </button>
          </div>
        </div>
      )}

      {/* Main content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, height: '100vh' }}>
        {/* Header */}
        <header className="app-header" style={{ borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fff', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            {/* Mobile hamburger */}
            <button className="mobile-menu-btn" onClick={() => setMobileMenu(true)}
              style={{ display: 'none', width: 40, height: 40, borderRadius: 10, border: '1px solid var(--border)', background: '#fff', alignItems: 'center', justifyContent: 'center', color: 'var(--text)', flexShrink: 0 }}>
              <Icon name="menu" size={20} />
            </button>
            <div style={{ minWidth: 0 }}>
              <h1 className="page-title" style={{ fontWeight: 800, color: 'var(--text)', letterSpacing: '-0.02em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{pageTitle}</h1>
              <p className="page-subtitle" style={{ color: 'var(--text-dim)', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{subTitle}</p>
            </div>
          </div>

          {/* User info */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
            <div className="header-user-text" style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{user.first_name} {user.last_name}</div>
              <div style={{ fontSize: 11, color: 'var(--text-dim)' }}>{userLabel}</div>
            </div>
            <div style={{ width: 38, height: 38, borderRadius: 12, background: 'linear-gradient(135deg, var(--accent), var(--violet))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
              {user.first_name?.[0]}{user.last_name?.[0]}
            </div>
            <button onClick={handleLogout} title="Chiqish" className="logout-btn" style={{ borderRadius: 12, border: '1.5px solid #fecaca', background: '#fef2f2', color: 'var(--red)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}>
              <Icon name="logout" size={16} />
            </button>
          </div>
        </header>

        {/* Scrollable content */}
        <main className="app-content" style={{ flex: 1, overflowY: 'auto' }}>
          <Outlet />
        </main>
      </div>

      {/* Responsive styles */}
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }
        .desktop-sidebar { display: block; }
        .mobile-menu-btn { display: none !important; }
        .app-header { padding: 16px 32px; }
        .app-content { padding: 28px; }
        .page-title { font-size: 22px; }
        .page-subtitle { font-size: 12px; }
        .logout-btn { width: 38px; height: 38px; }
        .header-user-text { display: block; }

        @media (max-width: 1024px) {
          .app-header { padding: 14px 20px; }
          .app-content { padding: 20px; }
        }
        @media (max-width: 768px) {
          .desktop-sidebar { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
          .app-header { padding: 10px 12px; }
          .app-content { padding: 12px; }
          .page-title { font-size: 17px; }
          .page-subtitle { font-size: 10px; }
          .header-user-text { display: none !important; }
          .logout-btn { width: 34px; height: 34px; }
        }
      `}</style>
    </div>
  );
}

function DashboardRouter() {
  const user = getUser();
  if (user?.role === 'mfy') return <MFYDashboardPage />;
  if (user?.role === 'tuman_admin') return <TumanDashboardPage />;
  return <DashboardPage />;
}

function PublicRoute() {
  const user = getUser();
  if (user && localStorage.getItem('access_token')) return <Navigate to="/" replace />;
  return <LoginPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<PublicRoute />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<DashboardRouter />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/mfy" element={<MFYPage />} />
          <Route path="/youth" element={<YouthPage />} />
          <Route path="/problems" element={<ProblemsPage />} />
          <Route path="/hokim" element={<HokimQuestionsPage />} />
          <Route path="/events" element={<PatrioticEventsPage />} />
          <Route path="/migrants" element={<MigrantsPage />} />
          <Route path="/ai" element={<AIModulePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
